/**
 * all actions for investment state
 *
 * Created by Tom on 16/06/18
 */

import C from '../constants'


// action to hide/show the loader for the investment
export const showInvestmentLoader = booleanVal => {
    return {
        type: C.SET_INVESTMENT_LOADER,
        payload: booleanVal
    }
}

// action to set the investment data
export const setInvestmentData = objectVal => {
    return {
        type: C.SET_INVESTMENT_DATA,
        payload: objectVal
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */



// WEBPACK FOOTER //
// ./src/actions/investmentActions.js